import React, { useState, useEffect } from 'react';
import { Container, Section } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useNewColorSchemaOptions from 'utils/hooks/useNewColorSchemaOptions';

import loadable from '@loadable/component';
const ExpansionPanel = loadable(() =>
  import('components/components/organisms/ExpansionPanel'),
);
const ExpansionContent = ({ fields, rendering }) => {
  const cta = getFieldValue(fields, 'cta');
  const description = getFieldValue(fields, 'description');
  const title = getFieldValue(fields, 'title');
  const openOnLanding = getFieldValue(fields, 'openOnLanding');
  const { newSchemaColorHexaCode, showNewSchemaColor } =
    useNewColorSchemaOptions();

  if (!description || !title) {
    return null;
  }

  return (
    <Section>
      <Container>
        <ExpansionPanel
          cta={cta}
          text={description}
          title={title}
          type='text'
          openOnLanding={openOnLanding}
          truncate={rendering?.componentName === 'ProductDescription'}
          newSchemaColorHexaCode={newSchemaColorHexaCode}
          showNewSchemaColor={showNewSchemaColor}
        />
      </Container>
    </Section>
  );
};

export default ExpansionContent;
